module.exports = __webpack_public_path__ + "static/media/Pham_Quang_Ha.7b22c0ae.png";